import { CustomUseQueryOptions } from '../types';
import type { ApiInstance, EventListItem } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export type EventsSearchParams = {
  page?: number;
  pageSize?: number;
  status?: number;
};

export const useEvents = (
  api: ApiInstance,
  searchParams: EventsSearchParams,
  options?: CustomUseQueryOptions<{ total: number; events: EventListItem[] }>
) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled,
    queryKey: [queryKey, 'Events', searchParams],
    queryFn: async () => {
      const { data } = await api.market.getEvents({
        page: searchParams.page,
        pageSize: searchParams.pageSize,
        status: searchParams.status,
      });
      return data;
    },
  });
};
